if (!window.vf) {
    window.vf = {};
}

vf['global-component-loader'] = (function (vf) {
    'use strict';

    function loadAndRender(url) {

        var promise = $.Deferred();

        vf['page-condition-checker'].init(url).then(function (config) {
            if (config) {
                //console && console.debug && console.debug('Loaded Config for ' + url, config);
                vf['condition-content-loader'].init(config).then(function (html) {
                    promise.resolve({
                        'config': config,
                        'data': html
                    });
                }).fail(function (e) {
                    console.warn('Problem with rendering a global component', config, e);
                });
            } else {
                console && console.debug && console.debug('No Config found for ' + url);
            }
        }).fail(function (e) {
            console.warn('Problem with loading a global component ' + url, e);
        });

        return promise;
    }

    return {
        'loadAndRender': loadAndRender
    };
})(vf);
